"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputVariantTypes = void 0;
var InputVariantTypes;
(function (InputVariantTypes) {
    InputVariantTypes["DEFAULT"] = "DEFAULT";
    InputVariantTypes["SNOWDROP"] = "SNOWDROP";
})(InputVariantTypes = exports.InputVariantTypes || (exports.InputVariantTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1pbnB1dHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvZm9ybS1pbnB1dHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQzNCLHdDQUFtQixDQUFBO0lBQ25CLDBDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQUc1QiJ9